import React, { useState } from "react";
import "./Home.css";
import Hero from "./components/hero/Hero";
import Value from "./components/value/Value";
import About from "./components/about/About";
import Footer from "./components/footer/Footer";
import Products from "./components/products/Products";
import Functionality from "./components/functionality/Functionality";

const Home = () => {
  
    

  return (
    <div className="Home">
      <Hero />
      <About />
      <Value />
      <Functionality />
      <Products />
      <Footer  />
    
    </div>
  );
};

export default Home;